import { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken, getStoredToken } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = getStoredToken();
        if (!token) {
            setLoading(false);
            return;
        }
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => setAuthToken(null))
            .finally(() => setLoading(false));
    }, []);

    const login = async (code) => {
        const r = await api.post("/auth/login", { code });
        setAuthToken(r.data.token);
        setUser(r.data.user);
        return r.data.user;
    };

    const logout = () => {
        setAuthToken(null);
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
